import { useEffect, useState } from "react";

const CDMX = { lat: 19.432608, lng: -99.133209 };

export const useMapaState = (initialLatLng) => {
  const initialLat = initialLatLng?.lat;
  const initialLng = initialLatLng?.lng;
  const [latLng, setLatLng] = useState(initialLatLng || CDMX);
  const [direccionActual, setDireccionActual] = useState(null);
  const [loadingDireccion, setLoadingDireccion] = useState(false);
  const [talleres, setTalleres] = useState(null);
  const [talleresVisibles, setTalleresVisibles] = useState(false);

  useEffect(() => {
    if (initialLat == null || initialLng == null) return;

    setLatLng({ lat: initialLat, lng: initialLng });
  }, [initialLat, initialLng]);

  const handleDireccionChange = (datos) => {
    setDireccionActual(datos);
    setLoadingDireccion(false);
  };

  const handleTalleresLoad = (data) => {
    setTalleres(data);
    setTalleresVisibles(true);
  };

  const handleTalleresToggle = () => setTalleresVisibles((v) => !v);

  return {
    latLng,
    setLatLng,
    direccionActual,
    loadingDireccion,
    setLoadingDireccion,
    handleDireccionChange,
    talleres,
    talleresVisibles,
    handleTalleresLoad,
    handleTalleresToggle,
  };
};
